// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__Mim1u","right":"styles_right__M_G9y"};